module.exports = __webpack_public_path__ + "img/Glenn.6a57676d.jpg";